import { comments } from "@/mocks/comments";

export default function CommentsPanel() {
  return (
    <div>
      <div className="rounded-lg bg-secondary-50 border border-secondary-200 px-4 py-3 mb-5 text-xs text-secondary-900 flex items-start gap-2">
        <i className="ri-error-warning-line mt-0.5"></i>
        <span>以下评论为前端演示文本，非真实用户互动，留言功能待接入后开放。</span>
      </div>

      <div className="space-y-3">
        {comments.map((item) => (
          <div key={item.id} className="rounded-lg bg-background-50 border border-background-200 p-4">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center font-bold text-sm">
                {item.user.slice(0, 1)}
              </span>
              <div className="flex-1">
                <p className="text-sm font-medium text-foreground-900">{item.user}</p>
                <p className="text-xs text-foreground-400">{item.time}</p>
              </div>
              <button
                type="button"
                disabled
                className="inline-flex items-center gap-1 text-xs text-foreground-400 cursor-not-allowed"
              >
                <i className="ri-thumb-up-line"></i> {item.likes}
              </button>
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed mt-3">{item.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
}